export enum CustomMatIconsEnum {
  forum = 'forum',
  qr = 'qr-codes',
  supervisor_account = 'supervisor_account',
  goods = 'toys',
  telegram = 'Telegram',
  telegram_round = 'telegramm-round',
  whats_up = 'WhatsApp',
}
